'use client';

import { useTranslation } from 'next-i18next';


export const CardRecommendedBadge = () => {
  const { t } = useTranslation('common');
  return (
    <div className="absolute -top-2 left-2 flex rounded-full bg-secondary px-2 py-0.5 text-pico text-white">
      {t('global.label.recommended')}
    </div>
  );
};
